import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type KnownCorrection = WithLegacy<{
  extractedName: string | null;
  correctedName: string | null;
  mentionType: string | null;
  externalId: string | null;
  externalSource: string | null;
  notes: string | null;
  createdAt: string | null;
  [Type]: 'known-corrections';
}>;

export const KnownCorrectionSchema = withDefaults({
  type: 'known-corrections',
  fields: [
    { name: 'extractedName', kind: 'attribute', type: 'string' },
    { name: 'correctedName', kind: 'attribute', type: 'string' },
    { name: 'mentionType', kind: 'attribute', type: 'string' },
    { name: 'externalId', kind: 'attribute', type: 'string' },
    { name: 'externalSource', kind: 'attribute', type: 'string' },
    { name: 'notes', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
  ],
});
